import { atom } from 'recoil';

export const appInitializationState = atom<boolean>({
  default: false,
  key: 'appInitializationState',
});
